import PropTypes from "prop-types"
import { intComma } from "humanize-plus"

import "./categories.scss"

const Categories = ({ categoriesTotal, topCategories, categoriesUrl }) => (
  <div className="stat-box category-service-stat-box" styleName="categories">
    <h3>Categories</h3>
    <div className="content">
      <div>
        <p className="stat">{intComma(categoriesTotal)}</p>
        <p className="caption">
          Unique categories your service is connected to
        </p>
        <p>
          <a className="caption" href={categoriesUrl}>
            View all {intComma(categoriesTotal)} categories
          </a>
        </p>
      </div>
      <div styleName="categories-top">
        <h4>Top 3 categories</h4>
        <ul>
          {topCategories.map(item => (
            <li key={item.id}>
              <a href={`${categoriesUrl}/${item.id}`}>
                <span styleName="highlight" />
                <span styleName="title">{item.name}</span>
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  </div>
)

Categories.propTypes = {
  categoriesTotal: PropTypes.number.isRequired,
  topCategories: PropTypes.array.isRequired,
  categoriesUrl: PropTypes.string.isRequired,
}

export default Categories
